export const environment = {
  production: false,
  apiUrl: 'https://laserapi.laser-point.it:50443/testapi',
  isTest: true,
  enableBugsnag: true,
};
